import HTTP from '@/utils/http';
import { EventBus } from '@/utils/event-bus';
import i18n from '@/locales';

const defaultState = () => ({
  invoicePreview: {},
});

const paygInvoicePreviewModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET(state, { preview }) {
      state.invoicePreview = preview;
    },
    CLEAR_PREVIEW(state) {
      state.invoicePreview = {};
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    GET({ commit }, quantity) {
      commit('CLEAR_PREVIEW');
      return HTTP({
        url: 'invoices/preview/pay-as-you-go-credits',
        params: {
          quantity,
        },
      }).then((response) => {
        commit('SET', { preview: response.data.data });
      }).catch(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.fail.fetch', { name: 'invoice preview' }), icon: 'times', type: 'error' }));
      });
    },
    ADD_VOUCHER({ commit }, { quantity, voucherCode }) {
      return HTTP({
        url: 'invoices/preview/pay-as-you-go-credits',
        params: {
          quantity,
          voucher_secret: voucherCode,
        },
      }).then((response) => {
          commit('CLEAR_PREVIEW');
        commit('SET', { preview: response.data.data });
        return { response };
      }).catch((error) => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.fail.fetch', { name: 'invoice preview' }), icon: 'times', type: 'error' }));
        return { error };
      });
    },
  },
  getters: {
    preview: state => state.invoicePreview,
  },
};

export default paygInvoicePreviewModule;
